import { Tabs,Button,Typography } from "antd";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setScreenHeader } from "shared/redux/common-reducer";
import BSAInput from "./BSAInput";
import BSAOutput from "./BSAOutput";
import arrowleft from "assets/images/arrow_left.svg";
import { useSelector } from "react-redux";
import { RootState } from "shared/redux/store";
import { ReactComponent as ArrowLeft } from "assets/images/arrow_left.svg";
import OIButton from "shared/ComponentsOI/OIButton/OIButton";

const { TabPane } = Tabs;
const { Title } = Typography;

interface IBankStatementAnalysis {
  setShowBSAOutputDetailsFor: Dispatch<SetStateAction<string>>;
  actionBack?: () => void;
  leadData?: any;
  bsaSelectedTab?: "INPUT" | "OUTPUT" | undefined ;
}

const BankStatementAnalysis: React.FC<IBankStatementAnalysis> = (
  props: IBankStatementAnalysis
) => {
  const { setShowBSAOutputDetailsFor, actionBack, leadData, bsaSelectedTab } = props;

  const { isBankAnalysisRequired}: any = useSelector((state: RootState) => state.common);

  const [activeKey, setActiveKey] = useState(bsaSelectedTab ?? "INPUT");
  const [closeWarningBSALocation, setCloseWarningBSAlocation] = useState("");

  return (
    <div className="close-case-box">
      <div className="heading" style={{
        display: "flex",
        justifyContent: "space-between",
        marginInline: "1.1rem",
      }}>
        <>
          <Title level={5}>
            Bank Statement Analysis
          </Title>
          {leadData?.caseDetails?.caseId &&
            <OIButton
              label="Back"
              size="middle"
              className="min-w-80"
              style={{"--custColor": "#4285F4"} as any}
              icon={<ArrowLeft style={{marginRight:"5px"}} />}
              onClick={() => {
                if(isBankAnalysisRequired) {
                  setCloseWarningBSAlocation("back");
                } else {
                  if (actionBack) {
                    actionBack();
                  }
                }
              }}
            />
          }
        </>
      </div>
      <>
      <Tabs
        activeKey={activeKey}
        onChange={(key: any) => setActiveKey(key)}
        type="card"
      >
        <TabPane tab="Input" key="INPUT">
          <BSAInput actionBack={actionBack} leadData={leadData} closeWarningBSALocation={closeWarningBSALocation} setCloseWarningBSAlocation={setCloseWarningBSAlocation}/>
        </TabPane>
        <TabPane tab="Output" key="OUTPUT">
          <BSAOutput setShowBSAOutputDetailsFor={setShowBSAOutputDetailsFor} leadData={leadData}/>
        </TabPane>
      </Tabs>
      </>
    </div>
  );
};

export default BankStatementAnalysis;
